import React, { useState, useEffect, useMemo, useContext } from 'react';
import _ from 'lodash';
import {
  Button,
  Grid,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { WorkReportContext } from './WorkReportForm';

const PrintManager = () => {
  const { t } = useTranslation();
  const { record, print, setShowObjectSummaryModal } = useContext(WorkReportContext);

  const reports = [
    { 
      formNumber: 'F2-1', 
      title: t("Atliktų darbų aktas (pagal įkainius su priskaitymais)"),
      printVariant: t('Atliktų darbų aktas įkainiui'), 
      type: 'workReportedByRate', 
      description: t("Spausdinami pasirinktu laikotarpiu įvykdyti darbai pagal įkainius sąmatoje, su visais papildomais priskaitymais įkainio vieneto kainoje")
    },
    { 
      formNumber: 'F2-2', 
      title: t("Atliktų darbų aktas (pagal įkainius)"),
      printVariant: t('Atliktų darbų aktas įkainiui su priskaitymais'), 
      type: 'workReportedByRateWithAdditions', 
      description: t("Spausdinami pasirinktu laikotarpiu įvykdyti darbai pagal įkainius sąmatoje, su kainos detalizacija pagal darbo užmokesčio, medžiagų ir mechanizmų išlaidas. Detalizuoti papildomi priskaitymai visiems darbams pateikiami dokumento pabaigoje")
    },
    { 
      formNumber: 'FP-1', 
      title: t("Priedas prie atliktų darbų akto"),
      printVariant: t('Priedas prie įvykdytų darbų akto'), 
      type: 'workReportedWithAdditions', 
      description: t("Spausdinamas pasirinktu laikotarpiu įvykdytų darbų resursų žiniaraštis, apimantis medžiagų, mechanizmų bei darbo sąnaudų kiekius ir kainas")
    },
  ]

  const onPrintLocalEstimate = async (params) => {
    const payload = {
      params: ['id'],
      values: [record._id],
      ...params,
    };

    await print(payload);
  };

  return (
    <div style={{ padding: '20px' }}>
      <Grid item style={{ paddingRight: 0, marginRight: -24 }}>
        <div style={{ margin: '8px 0px', display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ width: 130 }}>
            <Typography style={{ fontWeight: 600 }}>{t('Periodas')}</Typography>
            <Typography>{record?.period || ''}</Typography>
          </div>
          <div style={{ width: 130 }}>
            <Typography style={{ fontWeight: 600 }}>{t('Rangovas')}</Typography>
            <Typography>{record?.contractor || ''}</Typography>
          </div>
          <div style={{ width: 130 }}>
            <Typography style={{ fontWeight: 600 }}>{t('Darbų vadovas')}</Typography>
            <Typography>{record?.manager || ''}</Typography>
          </div>
          <div style={{ width: 130 }}>
            <Typography style={{ fontWeight: 600 }}>{t('Kainyno versija')}</Typography>
            <Typography>{record?.version?.version || ''}</Typography>
          </div>
          <div style={{ width: 130 }}>
            <Typography style={{ fontWeight: 600 }}>{t('Suma, EUR be PVM')}</Typography>
            <Typography>{record?.totals?.amountReported}</Typography>
          </div>
          <div style={{ width: 130, paddingLeft: 10 }}>
            <Typography style={{ fontWeight: 600 }}>{t('Suma, EUR su PVM')}</Typography>
            <Typography>{record?.totals?.grandTotal}</Typography>
          </div>
          <div style={{ paddingLeft: 10 }}>
            <Button
              variant="outlined"
              color="primary"
              style={{ fontSize: '10px', marginTop: '5px' }}
              onClick={() => setShowObjectSummaryModal(true)}>
              {t('Kainos sudėtis')}
            </Button>
          </div>
        </div>
      </Grid>
      <TableContainer style={{ maxHeight: '620px' }}>
        <Table stickyHeader >
          <TableHead>
            <TableRow>
              <TableCell colSpan={1} style={{ textAlign: 'center' }}>{t('Formos Nr.')}</TableCell>
              <TableCell colSpan={2} style={{ textAlign: 'center' }}>{t('Dokumento pavadinimas')}</TableCell>
              <TableCell colSpan={2} style={{ textAlign: 'center' }}>{t('Spausdinimo variantas')}</TableCell>
              <TableCell colSpan={3} style={{ textAlign: 'center' }}>{t('Trumpas aprašymas')}</TableCell>
              <TableCell colSpan={2} style={{ textAlign: 'center' }}>{t('Spausdinimo formatas')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map(({ formNumber, title, printVariant, description, type }) => (
              <TableRow key={type}>
                <TableCell colSpan={1}><b>{formNumber}</b></TableCell>
                <TableCell colSpan={2}><b>{title}</b></TableCell>
                <TableCell colSpan={2}>{printVariant}</TableCell>
                <TableCell colSpan={3}>{description}</TableCell>
                <TableCell colSpan={1} style={{ textAlign: 'center' }}>
                  <Button variant="outlined" color="primary" style={{ marginBottom: '3px' }} onClick={() => onPrintLocalEstimate({ fileType: 'PDF', type, formNumber })}>
                    PDF
                  </Button>
                  <Button variant="outlined" color="primary" onClick={() => onPrintLocalEstimate({ fileType: 'XLSX', type, formNumber })}>
                    XLSX
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default PrintManager;